export class DashboardStats {
  messagesNo: number;
  weekStats: ChartDataMulti[];
  getStarted: DashboardGetStarted;

  constructor() {
    this.messagesNo = 0;
    this.weekStats = [];
    this.getStarted = new DashboardGetStarted();
  }
}

export class DashboardGetStarted {
  completed: number;
  total: number;
  progress: number;
  items: DashboardGetStartedItem[];

  constructor() {
    this.completed = 0;
    this.total = 0;
    this.progress = 0;
    this.items = [];
  }
}

export class DashboardGetStartedItem {
  key: string;
  completed: boolean;

  constructor() {
    this.key = '';
    this.completed = false;
  }
}

export class ChartData {
  name: string;
  value: number;

  constructor() {
    this.name = '';
    this.value = 0;
  }
}

export class ChartDataMulti {
  name: string;
  series: ChartData[];

  constructor() {
    this.name = '';
    this.series = [];
  }
}
